package com.klantenstop.web.pages.authentication.resetPassword

import com.materialkobweb.components.toast.ToastManager
import com.klantenstop.web.data.repos.AuthRepo
import com.klantenstop.web.utils.Constants.PASSWORD_MIN_LENGTH
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ResetPasswordViewModel(
    token: String,
    private val authRepo: AuthRepo = AuthRepo
) : ViewModel(), ResetPasswordContract {

    private val _state = MutableStateFlow(ResetPasswordContract.State(token))
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<ResetPasswordContract.Effect>()
    override val effect = _effect.asSharedFlow()

    override fun sendIntent(intent: ResetPasswordContract.Intent) = coroutineScope.launch {
        when (intent) {
            is ResetPasswordContract.Intent.SubmitResetPassword -> submitResetPassword()
            is ResetPasswordContract.Intent.UpdatePassword -> updateState { it.copy(password = intent.value) }
            is ResetPasswordContract.Intent.UpdatePasswordConfirmation -> updateState { it.copy(passwordConfirmation = intent.value) }
        }
    }

    private suspend fun submitResetPassword() {
        val currentState = _state.value

        updateState { it.copy(hasAttemptedReset = true) }

        if (currentState.token.isEmpty()) {
            ToastManager.error("Ongeldige reset link", title = "Fout")
            return
        }

        if (currentState.password.length < PASSWORD_MIN_LENGTH) {
            ToastManager.warning("Wachtwoord moet minimaal $PASSWORD_MIN_LENGTH karakters bevatten", title = "Ongeldig wachtwoord")
            return
        }

        if (currentState.password != currentState.passwordConfirmation) {
            ToastManager.warning("Wachtwoorden komen niet overeen", title = "Ongeldige invoer")
            return
        }

        updateState { it.copy(isLoading = true) }

        try {
            authRepo.resetPassword(
                token = currentState.token,
                password = currentState.password,
                passwordConfirmation = currentState.passwordConfirmation
            )
            updateState { it.copy(isLoading = false) }
            ToastManager.success("Wachtwoord succesvol gereset! Je kunt nu inloggen.", title = "Gelukt")
            emitEffect(ResetPasswordContract.Effect.NavigateToLogin)
        } catch (e: Exception) {
            updateState { it.copy(isLoading = false) }
            ToastManager.error(
                e.message ?: "Er is iets misgegaan. Probeer het later opnieuw.",
                title = "Reset mislukt"
            )
        }
    }

    override fun emitEffect(effect: ResetPasswordContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (ResetPasswordContract.State) -> ResetPasswordContract.State) {
        _state.update(block)
    }
}

